export default {
  'order-id': 'Order ID',
  'full-name': 'Full Name',
  'trade-type': 'Trade Type',
  'trade-volume-million-usd': 'Trade Volume (Million USD)',
  'trade-instrument': 'Trade Instrument',
  'spread-rebate-ratio': 'Spread/Rebate Ratio',
  price: 'Price',
  'trade-time': 'Trade Time',
  'rebate-time': 'Rebate Time',
  'rebate-type': 'Rebate Type',
  'rebate-amount': 'Rebate Amount',
  'calculation-formula': 'Calculation Formula',
  status: 'Status',
  remarks: 'Remarks',
}
